import { BorderColors } from "@abel-technologies-as/components";
import styled from "styled-components";

const Container = styled.div``;

const TitleEvents = styled.div`
	border-bottom: 1px solid ${BorderColors.Secondary};
	padding-bottom: 21px;
`;

const EventsContainer = styled.div`
	max-height: 800px;
	overflow-y: auto;
`;

export { TitleEvents, Container, EventsContainer };
